import { Button, Stack, Typography } from '@mui/material'
import React from 'react'

const StartTeamsMeeting = () => {
  return (
    <Stack justifyContent="center" gap={3}>
      <Stack gap={2} justifyContent="center" alignItems="center">
        <Typography variant="title2">AmbuNet Live Support Session</Typography>
        <Typography variant="title3" color="contrast.main">
          Luke Jones would like to start a Microsoft Teams support meeting with
          you.
        </Typography>
      </Stack>
      <Typography>
        This session is intended to help AmbuNet support investigate an issue,
        guide you through a feature, or assist with system setup.
      </Typography>
      <Typography>
        Before joining, please make sure you understand the following:
        <ul>
          <li>
            Please do not share patient-identifiable information during the
            meeting.
          </li>
          <li>
            Please avoid displaying ePCRs, safeguarding records, clinical notes,
            medicines records, employee medical information, or other sensitive
            data unless specifically agreed and appropriately anonymised.
          </li>
          <li>
            You remain in control of your screen sharing and can stop sharing at
            any time.
          </li>
          <li>
            In some circumstances, you may choose to allow an AmbuNet support
            engineer temporary remote control to assist with troubleshooting or
            configuration.
          </li>
          <li>
            Only share the application window or browser tab needed for support.
          </li>
          <li>You can stop sharing or leave the meeting at any time.</li>
          <li>
            The session is for technical support purposes only and should not be
            used for urgent clinical, operational, or emergency matters.
          </li>
        </ul>
      </Typography>
      <Typography>
        By joining the meeting, you confirm that you will take reasonable steps
        to avoid sharing confidential or sensitive personal data.
      </Typography>
      <Typography>
        By joining the meeting, you also accept that meetings are recorded and
        digitally transcribed to help us continue debugging any issues
        encountered..
      </Typography>
      <Button
        onClick={() =>
          window.open(
            'https://teams.microsoft.com/meet/321778220404401?p=kV02kVUAayMjXS7kli',
          )
        }
        variant="contained"
      >
        Join Support Session
      </Button>
    </Stack>
  )
}

export default StartTeamsMeeting
